var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('NavTop')],1),_c('el-container',[_c('el-aside',{staticClass:"aside"},[_c('LeftNav')],1),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }